import React, { useContext as useContextCore } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { unitOfMeasureQueries } from '@ztechapps/product.common'

export type UnitOfMeasureProviderProps = {
  filterCategory?: string
  children: React.ReactNode
}
export type UnitOfMeasureListProps = Omit<UnitOfMeasureProviderProps, 'children'>

export type UnitOfMeasureContextType = {
  filterCategory: string
  unitOfMeasureList: UseListResult<UnitOfMeasure>
  onRefresh: () => Promise<void>
}

const context = React.createContext<UnitOfMeasureContextType>({} as UnitOfMeasureContextType)
const defaultFilterCategory = 'unitOfMeasureFilterCategory'

export const UnitOfMeasureProvider = ({ children, filterCategory }: UnitOfMeasureProviderProps) => {
  filterCategory = filterCategory ?? defaultFilterCategory
  const timeZone = useUserTimeZone()

  const unitOfMeasureList = useList<UnitOfMeasure>({
    query: unitOfMeasureQueries.allConfig.query,
    entity: unitOfMeasureQueries.allConfig.entity,
    sort: { category: 1, code: 1 },
    limit: 100,
    options: {
      queryOptions: {
        fetchPolicy: 'cache-and-network',
      },
    },
    listActionOptions: {
      storageKey: filterCategory,
      storageType: StorageType.localStorage,
      timeZone,
    },
  })

  const onRefresh = async () => {
    await unitOfMeasureList.refetch()
  }

  return <context.Provider value={{ filterCategory, unitOfMeasureList, onRefresh }}>{children}</context.Provider>
}

export const useUnitOfMeasureContext = () => useContextCore(context)
